// import {API_SERVER} from 'constants/index'
import store from "store/index";
import {
    danger,
} from 'actions/notification'
import {authFetched } from "actions/auth";


/*

This function maps the frontend window.location.href to the backend API server

*/

var getDomain = function() {

    // get domains
    const domains = store.getState().config;

    // get hostname
    var hostname = (new URL(window.location.href)).hostname;

    // return correct server address
    return domains[window.location.protocol.replace(':','')][hostname]['protocol']+'://'+domains[window.location.protocol.replace(':','')][hostname]['server'];

}

// define headers
export const auth = (login, password) => {
    // get server from store
    /*
    Previous code for getting backend server urls
    Andrew changed: 14/06/2019
    protocol + "://" + server REPLACED BY getDomain()
    */
    /*const {
        protocol,
        server,
    } = store.getState().config;
    */

    const headers = {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": "Basic " + btoa(login + ':' + password),
    }
    return fetch(getDomain() + 'auth', {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, same-origin, *omit
            headers: headers,
            redirect: "follow", // manual, *follow, error
            referrer: "no-referrer", // no-referrer, *client
        })
        .catch((e) => { store.dispatch(danger(e + '')); })
        .then((response) => response.json())
        .then(e => {
            if (e.error) {
                throw new Error(`${e.error}: ${e.errorMessage}`)
            } else
                return e;
        })
}

//Get requests
export const get = (url, params) => {

    // get server from store
    /*const {
        protocol,
        server
    } = store.getState().config;*/
    const headers = {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": "Bearer " + btoa(store.getState().auth.token),
    }
    
    //parse get params
    for (let name in params)
        if (params[name] === '')
            delete params[name]
    if (params)
        url += '?' + Object.keys(params).reduce(function(a, k) {
            a.push(k + '=' + encodeURIComponent(params[k]));
            return a
        }, []).join('&')
        //get request
    return fetch(getDomain() + url, {
            headers: headers
        })
        .catch((e) => { 
            store.dispatch(danger(e + '')); 
        })
        .then((response) => {
            if (!response){
                //throw new Error('No response from server')
                store.dispatch(authFetched({token:''}))
                return false
                // redirect to login
            }
            return response.json()
        })
        .then(e => {
            if (e && e.error) {
                if(e.error.includes('Not authenticated user') || e.error.includes('No authenticated users.')) {
                    store.dispatch(authFetched({token:''}))
                    return false
                }
                throw new Error(`${e.error}: ${e.errorMessage}`)
            } else
                return e;
        })
}

//Get requests
export const getFromRoot = (url, params) => {

    // get server from store
    /*const {
        protocol,
        server
    } = store.getState().config;*/
    const headers = {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": "Bearer " + btoa(store.getState().auth.token),
    }
    
    //parse get params
    for (let name in params)
        if (params[name] === '')
            delete params[name]
    if (params)
        url += '?' + Object.keys(params).reduce(function(a, k) {
            a.push(k + '=' + encodeURIComponent(params[k]));
            return a
        }, []).join('&')
        //get request
    return fetch(getDomain().replace('ibportal/','') + url, {
            headers: headers
        })
        .catch((e) => { 
            store.dispatch(danger(e + '')); 
        })
        .then((response) => {
            if (!response){
                //throw new Error('No response from server')
                store.dispatch(authFetched({token:''}))
                return false
            }
            return response.json()
        })
        .then(e => {
            if (e && e.error) {
                if(e.error.includes('Not authenticated user') || e.error.includes('No authenticated users.')) {
                    store.dispatch(authFetched({token:''}))
                    return false
                }
                throw new Error(`${e.error}: ${e.errorMessage}`)
                
            } else
                return e;
        })
}

//Get requests
export const getFromRootWithoutAuthorisation = (url, params) => {

    // get server from store
    /*const {
        protocol,
        server
    } = store.getState().config;*/
    const headers = {
        "Content-Type": "application/json; charset=utf-8"/*,
        "Authorization": "Bearer " + btoa(store.getState().auth.token),*/
    }
    
    //parse get params
    for (let name in params)
        if (params[name] === '')
            delete params[name]
    if (params)
        url += '?' + Object.keys(params).reduce(function(a, k) {
            a.push(k + '=' + encodeURIComponent(params[k]));
            return a
        }, []).join('&')
        //get request
    return fetch(getDomain().replace('ibportal/','') + url, {
            headers: headers
        })
        .catch((e) => { 
            store.dispatch(danger(e + '')); 
        })
        .then((response) => {
            if (!response){
                //throw new Error('No response from server')
                store.dispatch(authFetched({token:''}))
                return false
            }
            return response.json()
        })
        .then(e => {
            if (e && e.error) {
                if(e.error.includes('Not authenticated user') || e.error.includes('No authenticated users.')) {
                    store.dispatch(authFetched({token:''}))
                    return false
                }
                throw new Error(`${e.error}: ${e.errorMessage}`)
                
            } else
                return e;
        })
}

export const getContent = (url, params) => {

	// get server from store
	/*const {
			protocol,
			server
	} = store.getState().config;*/
	const headers = {
			"Content-Type": "application/json; charset=utf-8",
			"Authorization": "Bearer " + btoa(store.getState().auth.token),
	}
	
	//parse get params
	for (let name in params)
			if (params[name] === '')
					delete params[name]
	if (params)
			url += '?' + Object.keys(params).reduce(function(a, k) {
					a.push(k + '=' + encodeURIComponent(params[k]));
					return a
			}, []).join('&')
			//get request
	return fetch(getDomain() + url, {
					headers: headers
			})
			.catch((e) => { 
					store.dispatch(danger(e + '')); 
			})
			.then((response) => {
					if (!response){
							throw new Error('No response from server')
					}
					return response.text()
			})
			.then(e => {
					if (e && e.error) {
							if(e.error.includes('Not authenticated user') || e.error.includes('No authenticated users.')) {
									store.dispatch(authFetched({token:''}))
									return false
							}
							throw new Error(`${e.error}: ${e.errorMessage}`)
					} else
							return e;
			})
}


export const put = (url, params, returnErrorMsg=false) => {
    /*const {
        protocol,
        server
    } = store.getState().config;*/
    const headers = {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": "Bearer " + btoa(store.getState().auth.token),
    }
    return fetch(getDomain() + url, {
            method: "PUT", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, same-origin, *omit
            headers: headers,
            redirect: "follow", // manual, *follow, error
            referrer: "no-referrer", // no-referrer, *client
            body: JSON.stringify(params), // body data type must match "Content-Type" header
        })
        .catch((e) => { store.dispatch(danger(e + '')); })
        .then((response) => {
            if (!response){
                throw new Error('No response from server')
						}
            return response.text()
				})
				.then((text) => text.length ? JSON.parse(text) : {})
        .then(e => {
            if (e && e.error) {
                if(e.error.includes('Not authenticated user') || e.error.includes('No authenticated users.')) {
                    store.dispatch(authFetched({token:''}))
                    return false
                }
                throw new Error(`${e.error}: ${e.errorMessage}`)
            }
            else
                return e;
        })
}


export const remove = (url, params) => {
    /*const {
        protocol,
        server
    } = store.getState().config;*/
    const headers = {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": "Bearer " + btoa(store.getState().auth.token),
    }
    return fetch(getDomain() + url, {
            method: "DELETE", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, same-origin, *omit
            headers: headers,
            redirect: "follow", // manual, *follow, error
            referrer: "no-referrer", // no-referrer, *client
            body: JSON.stringify(params), // body data type must match "Content-Type" header
        })
        .catch((e) => { store.dispatch(danger(e + '')); })
        .then((response) => {
            if (!response){
                throw new Error('No response from server')
            }
            if (response.status !== 200){
                return response.text()
            }
            return ''
        })
        .then((text) => text.length ? JSON.parse(text) : {})
        .then(e => {
            if (e && e.error) {
                if(e.error.includes('Not authenticated user') || e.error.includes('No authenticated users.')) {
                    store.dispatch(authFetched({token:''}))
                    return false
                }
                throw new Error(`${e.error}: ${e.errorMessage}`)
            } else
                return e;
        })
}

export const post = (url, params, returnErrorMsg=false) => {
        /*const {
            protocol,
            server
        } = store.getState().config;*/
        const headers = {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer " + btoa(store.getState().auth.token),
        }
        return fetch(getDomain() + url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, same-origin, *omit
            headers: headers,
            redirect: "follow", // manual, *follow, error
            referrer: "no-referrer", // no-referrer, *client
            body: JSON.stringify(params), // body data type must match "Content-Type" header
        })

        .catch((e) => { store.dispatch(danger(e + '')); })
        .then((response) => {
            if (!response){
                throw new Error('No response from server')
            }
            return response.json()
        })
            .then(e => {
                if (e && e.error) {
                    if(e.error.includes('Not authenticated user') || e.error.includes('No authenticated users.')) {
                        store.dispatch(authFetched({token:''}))
                        return false
                    }
                    throw new Error(`${e.error}: ${e.errorMessage}`)
                }
                else
                    return e;
            })
    }
    //
    // export const del = (url) => {
    //   return fetch(API_SERVER + url, {method: 'delete'}).then(function(response) {
    //     return response.json();
    //   })
    // }


// WEBPACK FOOTER //
// ./src/actions/requests.js